import { render, staticRenderFns } from "./developmentDoc.vue?vue&type=template&id=700bf9c5&scoped=true"
import script from "./developmentDoc.vue?vue&type=script&lang=js"
export * from "./developmentDoc.vue?vue&type=script&lang=js"
import style0 from "./developmentDoc.vue?vue&type=style&index=0&id=700bf9c5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700bf9c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('700bf9c5')) {
      api.createRecord('700bf9c5', component.options)
    } else {
      api.reload('700bf9c5', component.options)
    }
    module.hot.accept("./developmentDoc.vue?vue&type=template&id=700bf9c5&scoped=true", function () {
      api.rerender('700bf9c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/openPlatform/developmentDoc.vue"
export default component.exports